/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_KcalInputs */

const en_filter_kcal = /** @type {(inputs: Filter_KcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kcal per portion`)
};

const de_filter_kcal = /** @type {(inputs: Filter_KcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kcal pro Portion`)
};

/**
* | output |
* | --- |
* | "kcal per portion" |
*
* @param {Filter_KcalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_kcal = /** @type {((inputs?: Filter_KcalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_KcalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_kcal(inputs)
	return en_filter_kcal(inputs)
});